export default __webpack_public_path__ + "media/images/java_logo-cd9a7278.svg";